module.exports = __webpack_public_path__ + "img/py.9f48a11.svg";